<script lang="ts">
	import type { IEventFilterOptionsStore } from '@stores/eventFilterOptions';
	import type { IEventFilterSelectionsStore } from '@stores/eventFilterSelections';
	import { getContext } from 'svelte';
	import type { Writable } from 'svelte/store';
	import DropdownMulti from './LpgComponents/DropdownMulti.svelte';
	import DateRangePickerInput from './LpgComponents/DateRangePicker/DateRangePickerInput.svelte';
	import { parseISO, formatISO } from 'date-fns';
	import Button from './Button.svelte';
	import ActionFilter from '@icons/ActionFilter.svelte';
	import Icon from './Icon.svelte';
	import Dropdown from './LpgComponents/Dropdown.svelte';
	import UserLocationButton from './UserLocationButton.svelte';
	import { EventSlotsApi } from '@api/EventSlotsApi';
	import CollapseUp from '@icons/CollapseUp.svelte';
	import EventTicketsFilterBarSearchInput from './EventTicketsFilterBarSearchInput.svelte';

	export let eventId: string;
	let className = '';
	export { className as class };

	let mobileFilterMenuOpen = false;

	const eventFilterOptions =
		getContext<Writable<IEventFilterOptionsStore>>('eventFilterOptionsStore');
	const eventFilterSelections = getContext<Writable<IEventFilterSelectionsStore>>(
		'eventFilterSelectionsStore'
	);

	const api = new EventSlotsApi();

	async function fetchFilterOptions() {
		const locationsResult = await api.options('location.address.city', {
			'event.id': eventId,
			_search_query: $eventFilterSelections.eventTicketsSearchText,
			'event.published_on~lte': formatISO(new Date(), { representation: 'date' }),
			'published_on~lte': formatISO(new Date(), { representation: 'date' }),
			'event.restrict_visibility': false,
			...($eventFilterSelections.eventSlotDateRange.start
				? { 'starts_at~gte': formatISO($eventFilterSelections.eventSlotDateRange.start) }
				: {}),
			...($eventFilterSelections.eventSlotDateRange.end
				? { 'starts_at~lte': formatISO($eventFilterSelections.eventSlotDateRange.end) }
				: {})
		});

		if (locationsResult.isOk()) {
			$eventFilterOptions.locations = locationsResult.value.data || [];
		}
	}

	$: if ($eventFilterSelections) fetchFilterOptions();
</script>

<div class="w-full flex flex-wrap gap-3 xl:gap-6 mb-6 {className}">
	<EventTicketsFilterBarSearchInput class="min-w-74 lg:flex-grow-0" />

	<UserLocationButton class="mr-auto lg:mr-0" />

	<Button
		variant="secondary"
		class="!h-[3.375rem] lg:!hidden !px-3"
		on:click={() => (mobileFilterMenuOpen = !mobileFilterMenuOpen)}
	>
		<Icon component={mobileFilterMenuOpen ? CollapseUp : ActionFilter} class="mr-1.5" />
		Filter
	</Button>

	<div
		class="w-full lg:w-auto flex flex-wrap gap-3 lg:gap-6 lg:!flex"
		class:hidden={!mobileFilterMenuOpen}
	>
		<DropdownMulti
			class=""
			label="Orte"
			id="location"
			options={$eventFilterOptions.locations.sort().map((location) => ({
				label: location,
				value: location
			}))}
			bind:selectedOptions={$eventFilterSelections.locations}
		/>
		<DateRangePickerInput
			class=""
			selectedRange={{
				start: $eventFilterSelections.eventSlotDateRange.start
					? parseISO($eventFilterSelections.eventSlotDateRange.start)
					: undefined,
				end: $eventFilterSelections.eventSlotDateRange.end
					? parseISO($eventFilterSelections.eventSlotDateRange.end)
					: undefined
			}}
			on:select={(e) => {
				const { start, end } = e.detail;

				$eventFilterSelections.eventSlotDateRange = {
					start: start ? formatISO(start) : undefined,
					end: end ? formatISO(end) : undefined
				};
			}}
		/>
	</div>

	<Dropdown
		label="Sortieren"
		id="sorting"
		class="lg:flex-grow-0 xl:ml-auto min-w-[18.375rem]"
		bind:selectedOption={$eventFilterSelections.sorting}
		options={[
			{ label: 'Relevanz', value: 'relevance_desc' },
			{ label: 'Datum aufsteigend', value: 'starts_at_asc' },
			{ label: 'Datum absteigend', value: 'starts_at_desc' }
		]}
	/>
</div>
